export default "/images/Ellipse.png?ddef85cc91ad039ac23b676680eac2b5";